import IconButton from '@/storybook/components/IconButton/IconButton';
import DownloadIcon from '@/storybook/icons/DownloadIcon';
import cx from 'classnames';
import { useEffect, useState } from 'react';
import styles from './DownloadButton.module.css';

type DownloadButtonState = 'default' | 'loading' | 'success' | 'error';
export interface DownloadButtonPureProps {
  'onDownload': () => Promise<void>;
  'disabled'?: boolean;
  'className'?: string;
  'aria-label'?: string;
  'data-testid'?: string;
}

export default function DownloadButton({
  onDownload,
  disabled = false,
  className,
  'aria-label': ariaLabel,
  'data-testid': dataTestId,
}: DownloadButtonPureProps) {
  const [iconState, setIconState] = useState<DownloadButtonState>('default');

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    if (iconState === 'success' || iconState === 'error') {
      timeoutId = setTimeout(() => {
        setIconState('default');
      }, 3000);
    }
    return () => clearTimeout(timeoutId);
  }, [iconState]);

  const handleClick = async () => {
    setIconState('loading');

    try {
      await onDownload();
      setIconState('success');
    } catch {
      setIconState('error');
    }
  };

  return (
    <IconButton
      appearance="text"
      size="M"
      className={cx(styles.downloadBtn, className, {
        [styles.success]: iconState === 'success',
        [styles.error]: iconState === 'error',
      })}
      loading={iconState === 'loading'}
      onClick={handleClick}
      icon={<DownloadIcon />}
      disabled={disabled}
      aria-label={ariaLabel}
      data-testid={dataTestId}
    />
  );
}
